import { ActionsObservable, ofType, StateObservable } from 'redux-observable';
import { of } from 'rxjs';
import {
    catchError,
    concatMap,
    filter,
    map,
    mergeMap,
    takeUntil,
} from 'rxjs/operators';

import { CommitmentService } from '../../../coaching-commitment/services/commitment.service';
import { Dependencies } from '../../../store';
import { PayloadAction } from '../../../store.model';

import {
    ActionType,
    Reload,
    reloadResult,
} from './observation.focus.summary.action';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const reload = (
    action: ActionsObservable<PayloadAction<ActionType, Reload>>,
    state: StateObservable<any>,
    deps: Dependencies,
) =>
    action.pipe(
        ofType(ActionType.COACHING__FOCUS_SUMMARY__RELOAD),
        mergeMap((act) => {
            const service =
                deps.injector.get<CommitmentService>(CommitmentService);

            return of(null).pipe(
                concatMap(() =>
                    service.getEvaluationsDetails(
                        act.payload.performerId,
                        act.payload.behaviourId,
                        act.payload.subBehaviourId,
                        act.payload.observationId,
                    ),
                ),
                map((ret) =>
                    reloadResult(
                        { ...act.payload, evaluationsDetails: ret },
                        act.storePath,
                    ),
                ),
                catchError(() =>
                    of(reloadResult({ ...act.payload }, act.storePath)),
                ),
                takeUntil(
                    action.pipe(
                        ofType(
                            ActionType.COACHING__FOCUS_SUMMARY__RELOAD_CANCEL,
                        ),
                        filter(
                            (cancelAct) =>
                                cancelAct.storePath === act.storePath,
                        ),
                    ),
                ),
            );
        }),
    );

export default [reload];
